import React, { ReactNode, useState } from 'react';
import { Statistic } from 'antd';

type Props = {
  color: string;
  backgroundColor: string;
  title: ReactNode;
  value: string | number;
  allowHover: boolean;
  onClick: () => any;
  loading?: boolean;
};
const FlowStatistic = (props: Props) => {
  const { color, backgroundColor, title, value, allowHover, onClick, loading } = props;

  const [hover, setHover] = useState<boolean>(false);

  return (
    <button
      className="outline-none bg-transparent w-full p-0 text-left block border-none"
      style={{ cursor: allowHover ? 'pointer' : 'default' }}
      onClick={event => {
        event.preventDefault();
        event.stopPropagation();
        onClick();
      }}>
      <Statistic
        title={title}
        valueStyle={{
          fontSize: '36px',
          fontWeight: 'bold',
          color: color,
        }}
        style={{
          backgroundColor: backgroundColor,
          opacity: hover && allowHover ? 0.8 : 1,
          transition: '0.3 ease',
          padding: '16px',
          borderRadius: '4px',
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        value={value}
        loading={loading}
      />
    </button>
  );
};

export default FlowStatistic;
